import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { LoaderComponent } from '@progress/kendo-angular-indicators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    LoaderComponent,
  ],
})
export class HeaderComponent {
  readonly title = input<string>('');
  readonly loading = input<boolean>(false);
}